import languageEn from '../../uni-credit-language/uni-credit-language-en';
import footerEn from '../../uni-credit-footer/uni-credit-footer-en';
import dateEn from '../../uni-credit-date-field/uni-credit-date-field-en';
import otpFormEn from '../../uni-credit-otp-form/locales/uni-credit-otp-form-en';
import scratchCardEn from '../../uni-credit-scratch-card/locales/uni-credit-scratch-card-en';
import accessBlockedEn from '../../uni-credit-access-blocked/locales/uni-credit-access-blocked-en';
import notPossibleEn from '../../uni-credit-not-possible/locales/uni-credit-not-possible-en';
import timerEn from '../../uni-credit-timer/locales/uni-credit-timer-en';
import createAndConfirmPasswordEn from '../../uni-credit-create-and-confirm-password/locales/uni-credit-create-and-confirm-password-en';
import createLoginEn from '../../uni-credit-create-login/locales/uni-credit-create-login-en';
import findBankOfficeEn from '../../uni-credit-find-bank-office/locales/uni-credit-find-bank-office-en';
import contactBankEn from '../../uni-credit-contact-bank/locales/uni-credit-contact-bank-en';

const locales = {
  ...languageEn,
  ...footerEn,
  ...dateEn,
  ...otpFormEn,
  ...scratchCardEn,
  ...accessBlockedEn,
  ...notPossibleEn,
  ...findBankOfficeEn,
  ...contactBankEn,
  ...timerEn,
  ...createAndConfirmPasswordEn,
  ...createLoginEn,
};

export default locales;